<template>
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-project @node-click="nodeClick"></erp-project>
  </div>
  <div class="d-flex-right">
    <el-button size="mini" type="primary text2"  @click="add" v-if="ERP.isPermission(4002010001)">分摊导入</el-button>
    <el-button size="mini" type="primary text2"  @click="excel" v-if="ERP.isPermission(4002010004)">下载分摊模板</el-button>
    <el-select size="mini" v-model="pindex_id" filterable placeholder="请选择"  class="kuan">
      <el-option
        key=""
        label="全部"
        value="">
      </el-option>
      <el-option
        v-for="item in options1"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <el-input size="mini" class="search" placeholder="请输入分摊名称" v-model="search" clearable></el-input>
    <el-button size="mini" type="primary text2" @click="change(1)">搜索</el-button>
    <!-- <div>这里的费用说明，如电费1度是0.5,这里的费用就是0.5。总金额是0.5*（本期读数-上期读数）</div> -->
    <v-divider></v-divider>
    <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left">项目</th>
            <th class="text-left">分摊费项</th>
            <th class="text-left">上期读数</th>
            <th class="text-left">本期读数</th>
            <th class="text-left">状态</th>
            <th class="text-left">计费周期</th>
            <th class="text-left">创建人</th>
            <th class="text-left">审核人</th>
            <th class="text-left">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text1" v-for="item in desserts" :key="item.id">
            <td >{{item.id}}</td>
            <td >{{item.pindex_name}}</td>
            <td >{{item.charge_name}}</td>
            <td >{{item.xsc_LastReadDegree}}</td>
            <td >{{item.xsc_CurrentReadDegree}}</td>
            <td >{{item.status}}</td>
            <td >{{item.date}}</td>
            <td >{{item.user}}</td>
            <td >{{item.status_user}}</td>
            <td class="cdj_td">
              <div style="color: #1867c0;cursor: pointer;" @click="xzai(item)">下载</div>
              <div style="color: #1867c0;cursor: pointer;margin-left: 5px;" @click="xiugai(item)" v-if="item.status == '待审核'">审核</div>
              <div style="color: red;margin-left: 5px;cursor: pointer;" @click="refuse( item.id )" v-if="item.status == '待审核'">拒绝</div>
              <!-- <div style="margin-left: 5px;cursor: pointer;" @click="xiugai(item,6)" v-if="item.status!='待审核'">查看</div> -->
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="desserts">
      <Page :total="total" :page-size="page" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
  </div>
    <!-- 导入分摊费用 -->
    <Modal
        v-model="modals"
        :ok-text="oktext"
        :loading="loadings"
        width="600"
        :title="title"
        @on-ok="addPost">
        <el-form  label-width="80px" style="height: 660px;overflow: auto;">
          <el-form-item label="选择项目" :rules="[{required: true}]">
               <el-select v-model="dadepost.pindex_id" style="width: 100%;"  @change="changess(dadepost.pindex_id)" filterable placeholder="请选择项目">
                <el-option
                  v-for="item in options2"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="分摊费项" :rules="[{required: true}]">
              <el-select v-model="dadepost.charge_id" style="width: 100%;" filterable placeholder="请选择">
                <el-option
                  v-for="item in types"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
          </el-form-item>
         <el-form-item label="上期读数" :rules="[{required: true}]">
            <el-input v-model="dadepost.xsc_LastReadDegree" placeholder="上期读数"></el-input>
          </el-form-item>
          <el-form-item label="本期读数" :rules="[{required: true}]">
            <el-input v-model="dadepost.xsc_CurrentReadDegree" placeholder="本期读数"></el-input>
          </el-form-item>
          <el-form-item label="计费周期" :rules="[{required: true}]" v-if="dadec == 1">
              <el-date-picker
                v-model="datevalue"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
          </el-form-item>
          <el-form-item label="计费周期" :rules="[{required: true}]" v-if="dadec == 2">
              {{dadepost.sdate}}至{{dadepost.enddate}}
          </el-form-item>
          <el-form-item label="上传文件" :rules="[{required: true}]">
              <el-upload
                class="upload-demo"
                :action="url"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :on-success="handleAvatarSuccess"
                accept=".xls,.xlsx"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList"
                :before-upload="beforeAvatarUpload">
                <el-button size="small" type="primary" class="texts">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传xls或xlsx文件，且不超过7M</div>
              </el-upload>
          </el-form-item>
        </el-form>
    </Modal>

    <Modal
        v-model="modals1"
        ok-text="下载模板"
        :loading="loadings"
        width="600"
        title="下载分摊费用模板"
        @on-ok="addExcel">
        <el-form  label-width="80px" style="height: 660px;overflow: auto;">
          <el-form-item label="选择项目" :rules="[{required: true}]">
               <el-select v-model="dadepost.pindex_id" style="width: 100%;"  @change="changess(dadepost.pindex_id)" filterable placeholder="请选择项目">
                <el-option
                  v-for="item in options2"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
          </el-form-item>
        </el-form>
    </Modal>

</div>
</template>

<script>
import ErpProject from "../Common/erp-project";
import imgurl from "../../../assets/js/imgurl.js";
export default {
  name: "pindexShareEnter",
  components: {ErpProject},
  data () {
    return {
     url:'',
     fileList:[],
     dadec:1,
     oktext:'保存',
     title:'添加分摊费用',
     loadings:true,
     modals:false,
     modals1:false,
     types:[],
     typesvalyel:'',
     activeName: '0',
     search:'',
     company_id:'',
     pindex_id:'',
     desserts: '',
     total:12,
     page:1,
     cs:'',
     dadepost:{
       id:'',
       pindex_id:'',
       charge_id:'',
       xsc_LastReadDegree:'',
       xsc_CurrentReadDegree:'',
       url:'',
       sdate:'',
       enddate:'',
     },
     datevalue:[],
     options1: [],
     options2:[],
     node_had: [],
     resolve_had: [],
     name:'',
     typeSelect:'',
    }
  },
  //界面没出来前加载
  created() {
  },
  mounted(){
    var login = window.localStorage.getItem('login');
    var token = window.localStorage.getItem('token');
    this.url = this.$myhttp.defaults.baseURL + "/admin/excel"+"?login_name="+login+"&token="+token;
    this.change(1);
    //加载公司列表和归属列表
    this.$myhttp.get('admin/getcompany',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.options = backdata.data[0];
    });
    //我和我下级的项目
    this.$myhttp.get('admin/common/pindex',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
         this.options1 = backdata.data.data;
         this.options2 = backdata.data.data;
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  methods: {
    //上传
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },
    //超过一个文件
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    //删除
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    //限制大小
    beforeAvatarUpload(file){
      const isLt7M = file.size / 1024 / 1024 < 7;
      if (!isLt7M) {
        this.$message.error('上传文件大小不能超过 7MB!');
      }
      return isLt7M;
    },
    handleAvatarSuccess(res, file){
      this.dadepost.url = file.response[0];
    },

    //下载查看
    xzai(it){
      let urls = imgurl+it.url;
      window.open(urls, '_blank');
    },

    excel(){
      this.modals1 = true;
    },
    //下载模板
    addExcel(){
      let pindex_id = this.dadepost.pindex_id;
      if(!pindex_id){
        this.$Message.error('项目不能为空');
        this.loading();
        return false;
      }
      ERP.showLoading()
      this.$myhttp.get('admin/ShareEnter/excel?pindex_id='+pindex_id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.modals1 = false;
          ERP.hideLoading()
          let urls = imgurl+backdata.data.data;
          window.open(urls, '_blank');
      });
    },
    nodeClick(e){
      this.pindex_id=e.id;
      this.dadepost.pindex_id = e.id;
      this.change(1)
    },
    //查询
    change(page){
      this.modals = false;
      ERP.showLoading()
      this.$Loading.start();
      this.$myhttp.get('admin/ShareEnter/index?page='+page+'&pindex_id='+this.pindex_id+'&search='+this.search,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data.data;
          this.total = backdata.data.count;
          this.page = backdata.data.page;
          this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    //项目改变查询收费项
    changess(pindex_id){
      this.$Loading.start();
      this.$myhttp.get('admin/ShareEnter/charge?pindex_id='+pindex_id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.types = backdata.data.data;
          this.$Loading.finish();
          this.dadepost.charge_id = '';
          this.$forceUpdate();
      });
    },
    //点击添加
    add(){
      this.dadec = 1;
      let pid = this.dadepost.pindex_id;
      this.dadepost={
        id:'',
        pindex_id:'',
        charge_id:'',
        xsc_LastReadDegree:'',
        xsc_CurrentReadDegree:'',
        sdate:'',
        enddate:'',
        url:'',
      };
      if(pid){
        this.dadepost.pindex_id = pid;
        this.changess(this.dadepost.pindex_id);
      }
      this.$forceUpdate();
      this.oktext='保存';
      this.title='导入分摊费用';
      this.modals = true;
    },
    //新增和修改保存,审核
    addPost(){
      if(this.dadepost.pindex_id == ''){
        this.$Message.error('项目不能为空');
        this.loading();
        return false;
      }
      if(this.dadepost.charge_id == ''){
        this.$Message.error('分摊费用不能为空');
        this.loading();
        return false;
      }
      if(this.dadepost.xsc_LastReadDegree == ''){
        this.$Message.error('上期读数不能为空');
        this.loading();
        return false;
      }
      if(this.dadepost.xsc_CurrentReadDegree == ''){
        this.$Message.error('本期读数不能为空');
        this.loading();
        return false;
      }
      if(this.datevalue != null && this.datevalue != ''){
        var d = this.datevalue[0];//开始时间
        var e = this.datevalue[1];//结束时间
        this.dadepost.sdate = new Date(d).getTime()/1000;
        this.dadepost.enddate = new Date(e).getTime()/1000;
      }else{
        this.dadepost.sdate = "";
        this.dadepost.enddate = "";
      }
      if(this.dadepost.sdate == ""){
        this.$Message.error('计费周期不能为空');
        this.loading();
        return false;
      }
      if(this.dadepost.url == ''){
        this.$Message.error('文件不能为空');
        this.loading();
        return false;
      }

      this.$myhttp.post('admin/ShareEnter/add',this.dadepost,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{
          this.change(1);
          this.$Message.success('操作成功');
          this.$Loading.finish();
          this.dadepost={
            id:'',
            pindex_id:'',
            charge_id:'',
            xsc_LastReadDegree:'',
            xsc_CurrentReadDegree:'',
            sdate:'',
            enddate:'',
            url:'',
          };
          this.fileList = [];

      });

    },
    //拒绝通过
    refuse(id){
      this.$confirm('确定要拒绝通过吗', '提示', {
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$myhttp.post('admin/ShareEnter/refuse',{'id':id},{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{
            this.change(1);
            this.$Message.success('操作成功');
            this.$Loading.finish();
        });
      }).catch(() => {
      });
    },
    //审核通过
    xiugai(item){
      this.$confirm('确定要审核通过吗', '提示', {
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        this.$myhttp.post('admin/ShareEnter/check',item,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{
            ERP.hideLoading()
            if(backdata.data.code == 201){
               this.$Message.error(backdata.data.message);
            }
            if(backdata.data.code == 200){
              this.change(1);
              this.$Message.success('操作成功');
            }
        });
      }).catch(() => {
        ERP.hideLoading()
      });
    },

    loading(){
      this.loadings = false;
      let _this = this;
      setTimeout(() => {
          _this.loadings = true;
      }, 100);
    }

  },
  watch: {
    //两个懒加载方法
    'dadepost.type'(val){
      this.node_had.childNodes = [];
    },
    'dadepost.pindex_id'(val){
      this.node_had.childNodes = []; //把存起来的node的子节点清空，不然会界面会出现重复树！
      let _this = this;
      this.options2.forEach(function(it){
        if(val == it.id){
          _this.name = it.name;
        }
      })
    },
  }
}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.zhujie{
  margin-left: 14%;
  color: brown;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 12%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.text3{
  color: rgb(9, 145, 145);
}
.bangd{
  margin-left: 14%;
  color: rgb(6, 141, 107);
}
.item{
  margin-top: 1%;
}
.d-flex {
    display: flex;
  }

  .d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
  }

  .d-flex-right {
    flex: 1;
  }
  .upload-demo{
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/ShareEnter.vue